site.megamenu = {
	hasExtras:[],
	init:function() {
		var $mainmenu = $('#mainmenu'),
			$body = $('body');

		const frontpage = $body.hasClass('forsida');

		$('.mmLevel2', $mainmenu).wrap('<div class="megamenu ' + (frontpage ? 'frontpage' : '') + '"><div class="wrap"><div class="contentWrap" /></div></div>');
		$mainmenu.on('click', function(e) {
			e.stopPropagation();
		});

		$('.level1.children > a',$mainmenu).on('click', function (e) {
			if ($(document).width()+15 >= 992 && !$('body').hasClass('stillingar')) {
				e.preventDefault();
				e.stopPropagation();

				//Click on node that is already open
				if ($(this).parent().hasClass('open')) {
					site.megamenu.close();
				}
				//Open megamenu
				else {
					const $target = $(e.currentTarget);
					const codename = $target.attr('href').split('/').slice(-1)[0];

					$body.addClass('megamenu-open');
					$('.level1.open', $mainmenu).removeClass('open');
					$('.megamenu', $mainmenu).removeAttr('style');
					$(this).parent().addClass('open');

					$('a.level-1-menu-item', $mainmenu).removeClass('selected');
					$('a.level-1-menu-item.' + codename, $mainmenu).addClass('selected');
					site.megamenu.setHeight();
				}
			}
		});

		$body.on('click', function (e) {
			if ($body.is('.frontpage')) {
				site.megamenu.close();
			}
		});
		$(document).keydown(function (e) {
			if (e.which === 27 && $body.hasClass('megamenu-open')) {
				site.megamenu.close();
				var $level1 = $(e.target).closest('.level1');
				$('> a', $level1).focus();
			}
		});

		$(window).resize(function() {
			site.megamenu.setHeight();
		});

		if (!frontpage) {
			const elements = $('#mainmenu .level1.children > a').clone();

			elements.each((i, el) => {
				const $line = $('<div class="line"></div>')
				const $el = $(el);
				const codename = $el.attr('href').split('/').slice(-1)[0];
				$line.attr('style', 'background: '+ $el.data('color'));
				$el.append($line);
				$el.addClass(codename);
				$el.addClass('level-1-menu-item');
			});

			const megamenuContentWrap = $(' #mainmenu .megamenu .contentWrap');

			elements.on('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				const $target = $(e.currentTarget);
				const codename = $target.attr('href').split('/').slice(-1)[0];

				$('.level1.open', $mainmenu).removeClass('open');
				$('.megamenu', $mainmenu).removeAttr('style');
				$('.level1.ele-' + codename, $mainmenu).addClass('open');

				$('a.level-1-menu-item', $mainmenu).removeClass('selected');
				$('a.level-1-menu-item.' + codename, $mainmenu).addClass('selected');
				site.megamenu.setHeight();
			});
			const $closeButton = $('<div class="close-button"></div>');

			$closeButton.on('click', (ev) => {
				site.megamenu.close();
			});
			megamenuContentWrap.prepend($closeButton);
			megamenuContentWrap.prepend(elements.wrapAll('<div class="level1-menu"></div>').parents());
		}
		//site.megamenu.loadLinks();
	},

	setHeight:function() {
		var $megamenu = $('.megamenu', '#mainmenu .level1.open');
		if ($megamenu.length > 0) {
			var $megamenuHeight = $megamenu[0].scrollHeight + 5;
			$megamenu.css('max-height', $megamenuHeight);
			$('#pageContainer').css('min-height', $megamenuHeight+142);
		}
	},

	close:function() {
		var $body = $('body'),
			$mainmenu = $('#mainmenu');
		$('.megamenu', $mainmenu).removeAttr('style');
		$('.level1.open', $mainmenu).removeClass('open');
		$('#pageContainer').removeAttr('style');

		if ($body.hasClass('megamenu-open')) {
			$body.addClass('megamenu-closing');
			setTimeout(function() {
				$body.removeClass('megamenu-closing');
			},400);
		}
		$body.removeClass('megamenu-open');
	},

	loadLinks:function() {
		$('.megamenu', '#mainmenu').each(function() {
			var $megamenu = $(this),
				$li = $megamenu.parents('.level1'),
				$a = $li.find("> a:not(.expand)"),
				href = $a.attr('href'),
				codename = (href) ? href.replace('/is/', '') : '';

			if (site.megamenu.hasExtras.indexOf(codename) >= 0) {
				$.ajax({
					url: '/moya/extras/megamenu-'+codename,
					type: 'get'
				}).done(function(r) {
					if (r.length) {
						$megamenu.find('.contentWrap').append(r);
					}
				});
			}

			if (codename === 'mannlif') {
				$('.mmLevel2', $megamenu).remove();
			}
		});
	}
};
